/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Defines the type of session
 */ 
export enum SessionType {
    TeamTrainingSession = 1,
    NonSimulation = 2,
    Exam = 3,
    PeerPractice = 4,
    MultiRoomRecording = 5,
    AutomaticRecording = 6,
}
